<script setup lang="ts">
import type { DialogDescriptionProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { DialogDescription, useForwardProps } from 'reka-ui';
import { computed } from 'vue';

const props = defineProps<
	DialogDescriptionProps & { class?: HTMLAttributes['class'] }
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<DialogDescription
		v-bind="forwardedProps"
		:class="cn('text-sm text-muted-foreground', props.class)"
	>
		<slot></slot>
	</DialogDescription>
</template>
